/** Compact send button with a paper plane icon (user request 2026-09-27: more room for the input). */
export function SendButton(props: { label: string; disabled?: boolean; private?: boolean }) {
  return (
    <button
      class={`btn btn-primary btn-small send-btn ${props.private ? 'private' : ''}`}
      type="submit"
      disabled={props.disabled}
      title={props.label}
      aria-label={props.label}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
        <path d="M3.4 20.4 21 12 3.4 3.6 3.4 10.2 15 12 3.4 13.8z" />
      </svg>
      {props.private && <span class="send-lock" aria-hidden="true">🔒</span>}
    </button>
  );
}
